<template>
  <b-form-group class="checkbox-pointer">
    <b-form-checkbox-group
      v-model="value"
      :disabled="disabled"
      :options="bsOptions"
      :name="schema.model"
      :id="getFieldID(schema)"
      :required="schema.required"
      :stacked="schema.stacked || true"
    >
    </b-form-checkbox-group>
  </b-form-group>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
  computed: {
    bsOptions() {
      const options = [];
      this.schema.options.forEach((option) => {
        options.push({ value: option.id, text: option.text });
      });

      return options;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldMultipleCheckbox.vue